import React, { useEffect } from "react";
import { Box, Flex, Grid, GridItem } from "@chakra-ui/react";
import DashboardBarChart from "../components/DashboardBarChart";
import DashboardLineChart from "../components/DashboardLineChart";
import UpcomingExams from "../components/UpcomingExams";
import { fetchAdminDashboard } from "../redux/slices/dashboardSlice";
import { useDispatch, useSelector } from "react-redux";
import DashboardDisplayCards from "../components/DashboardDisplayCards";
import img1 from "../Assets/Images/dcard-image-1.png";
import img2 from "../Assets/Images/dcard-image-2.png";
import img3 from "../Assets/Images/dcard-image-3.png";
import img4 from "../Assets/Images/dcard-image-4.png";
import AdminDashboardGenderReport from "../components/AdminDashboardGenderReport";
import DasboardCards from "../components/DasboardCards";
import AdminDashboardExamReport from "../components/AdminDashboardExamReport";
import DashboardActivityBarChart from "../components/DashboardActivityBarCharts";

const AdminDashboard = () => {
  const dispatch = useDispatch();
  const adminDashboardData = useSelector(
    (state) => state?.dashboard?.adminDashboard
  );
  useEffect(() => {
    dispatch(fetchAdminDashboard());
  }, [dispatch]);

  const details = [
    {
      name: "Total Number Of Students",
      number: adminDashboardData?.memberCategoryCount?.totalStudent,
      bgcolor: "#FFF6EC",
      icon: img1,
      imgBgColor: "#FFE9BC",
    },
    {
      name: "Total Number Of NYSC Members",
      number: adminDashboardData?.memberCategoryCount?.totalNYSC,
      bgcolor: "#FCEAE4",
      icon: img2,
      imgBgColor:"#F8D4C8"
    },
    {
      name: "Total Number Of Graduates",
      number: adminDashboardData?.memberCategoryCount?.totalGraduate,
      bgcolor: "#EFE6F6",
      icon: img3,
      imgBgColor:"#E7D1F8"
    },
    {
      name: "Total Number Of Fellows",
      number: adminDashboardData?.memberCategoryCount?.totalFellow,
      bgcolor: "#FFECF0",
      icon: img1,
      imgBgColor:"#F4BCCA"
    },
    {
      name: "Total Number Of Associates",
      number: adminDashboardData?.memberCategoryCount?.totalAssociate,
      bgcolor: "#EDF2FB",
      icon: img4,
      imgBgColor:"#416EFC4A"
    },
  ];

  const paidSubsriptionData =  {
    name: "Total Members With Paid Subscription",
    number: 
    (adminDashboardData?.membersWithPaidSubscription?.associate || 0) +
    (adminDashboardData?.membersWithPaidSubscription?.fellow || 0) +
    (adminDashboardData?.membersWithPaidSubscription?.graduate || 0) +
    (adminDashboardData?.membersWithPaidSubscription?.nysc || 0) +
    (adminDashboardData?.membersWithPaidSubscription?.student || 0),
    colors: ["#FFE7B9", "#FCEAE4", "#EDA3AA", "#812773", "#3064FC"],
    pieChartData: [
      { name: "Students", value: adminDashboardData?.membersWithPaidSubscription?.student },
      { name: "NYSC", value: adminDashboardData?.membersWithPaidSubscription?.nysc },
      { name: "Associates ", value: adminDashboardData?.membersWithPaidSubscription?.associate },
      { name: "Fellows", value: adminDashboardData?.membersWithPaidSubscription?.fellow },
      { name: "Graduates ", value: adminDashboardData?.membersWithPaidSubscription?.graduate },
    ],
  }

const examStats = adminDashboardData?.examReport;

const total = examStats?.totalQualifiedStudents + examStats?.totalUnqualifiedStudents;
const wroteExam = examStats?.totalStudentsWhoWroteExam || 0;
const qualified = examStats?.totalQualifiedStudents || 0;
const unqualified = examStats?.totalUnqualifiedStudents || 0;

  const examReportData = {
    title: "Exam Report",
    color1: "#1976D2",
    color2: "#812773",
    color3: "#EB3D4D",
    text1: "No of Students That wrote exam",
    text2: "No of qualified students",
    text3: "No of unqualified students",
    value1: total > 0 ? `${((wroteExam / total) * 100).toFixed(2)}%` : "0%",
    value2: total > 0 ? `${((qualified / total) * 100).toFixed(2)}%` : "0%",
    value3: total > 0 ? `${((unqualified / total) * 100).toFixed(2)}%` : "0%",
  };
  const memberStats = adminDashboardData?.memberReport;

  const totalMembers = memberStats?.totalMembers || 0;
  const totalNonMembers = memberStats?.totalNonMembers || 0;
  const totalOldMembers = memberStats?.totalOldMembers || 0;
  
  const memberReportData = {
    title: "Member Report",
    color1: "#F86624",
    color2: "#22CAAD",
    color3: "#EB3D4D",
    text1: "Total Members",
    text2: "Total Non-Members",
    text3: "Total Old Members",
    value1: totalMembers.toLocaleString(),
    value2: totalNonMembers.toLocaleString(),
    value3: totalOldMembers.toLocaleString(),
  };
  
  return (
    <Flex
      flexDirection={"column"}
      gap={"20px"}
      py={"30px"}
      minH={"100vh"}
      px={3}
    >
      <Flex
        flexDirection={["column", "column", "column", "row"]}
        justifyContent={["center", "center", "flex-start"]}
        alignItems={"center"}
        gap={"20px"}
      >
        <Box w={["100%", "100%", "100%"]} bgColor={"#FFFFFF"} borderRadius={"14px"} border={"1px solid #E3EBEE"} padding={"20px"}>
          <Grid gridTemplateColumns={["repeat(1, 1fr)", "repeat(2, 1fr)","repeat(3, 1fr)","repeat(4, 1fr)", "repeat(5, 1fr)"]} gap={5}>
          {
            details?.map((detail, index) => (
              <GridItem>
                <DashboardDisplayCards key={index} {...detail} />
              </GridItem>
            ))
          }
          </Grid>
        </Box>
      </Flex>
      <Flex
        mt={6}
        flexDirection={["column", "column", "column", "row"]}
        justifyContent={["center", "center", "space-between"]}
        alignItems={"center"}
        gap={"20px"}
      >
        <Box w={["100%", "100%", "100%", "60%", "70%"]}>
          <DashboardLineChart
            lineChartData={adminDashboardData?.memberCountPerMonth}
          />
        </Box>
        <Box width={["100%", "100%", "100%", "40%", "30%"]}>
          <UpcomingExams
            upcomingEvents={adminDashboardData?.events}
            title={"Upcoming Events"}
          />
        </Box>
      </Flex>
      <Grid gridTemplateColumns={["repeat(1, 1fr)", "repeat(2, 1fr)","repeat(2, 1fr)", "repeat(2, 1fr)"]} gap={5}>
        <GridItem>
        <AdminDashboardGenderReport genderReport={adminDashboardData?.genderReport} />
        </GridItem>
        <GridItem>
        <DasboardCards
          showValue={false}
          name={paidSubsriptionData?.name}
          number={paidSubsriptionData?.number}
          colors={paidSubsriptionData?.colors}
          pieChartData={paidSubsriptionData?.pieChartData}
        />
        </GridItem>
      </Grid>
      <DashboardBarChart barChartData={adminDashboardData?.memberUpgradeCounts} />
      <DashboardActivityBarChart barChartData={adminDashboardData?.activityReports} />
      <Grid gridTemplateColumns={["repeat(1, 1fr)", "repeat(2, 1fr)","repeat(1, 1fr)", "repeat(1, 1fr)"]} gap={5}>
        <GridItem>
          <AdminDashboardExamReport {...examReportData} />
        </GridItem>
        <GridItem>
          <AdminDashboardExamReport {...memberReportData} />
        </GridItem>
      </Grid>
    </Flex>
  );
};

export default AdminDashboard;
